module.exports = __webpack_public_path__ + "static/basen-woda_thumb-e0500fadce6829c1159e43a62a21d762.jpg";